import { type Crop } from 'react-image-crop';

import { getFileMime } from 'app/main/components/files-explorer/FilesUtils';

export enum AspectRatios {
	'16:9' = 16 / 9,
	'1:1' = 1 / 1,
	'4:3' = 4 / 3
}

export function exportImage(image: HTMLImageElement, crop: Partial<Crop>, fileName: string) {
	const fileMime = getFileMime(fileName);

	const canvas = document.createElement('canvas');

	const scaleX = image.naturalWidth / image.width;
	const scaleY = image.naturalHeight / image.height;

	const ctx = canvas.getContext('2d');

	if (fileMime !== null && ctx !== null) {
		const width = crop.width || image.width;
		const height = crop.height || image.height;

		const pixelRatio = window.devicePixelRatio;
		canvas.width = width * pixelRatio;
		canvas.height = height * pixelRatio;
		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
		ctx.imageSmoothingQuality = 'high';

		ctx.drawImage(
			image,
			(crop?.x || 0) * scaleX,
			(crop?.y || 0) * scaleY,
			width * scaleX,
			height * scaleY,
			0,
			0,
			width,
			height
		);
		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

		return new Promise<Blob | null>((resolve, reject) => {
			canvas.toBlob(blob => resolve(blob), fileMime, 1);
		});
	} else throw Error('"ctx" is null!');
}

export function rotateImage(imageSrc: string, angle: number, fileName: string) {
	const fileMime = getFileMime(fileName);

	const canvas = document.createElement('canvas');

	const ctx = canvas.getContext('2d');

	if (fileMime !== null && ctx !== null) {
		const image = document.createElement('img');
		image.src = imageSrc;

		const { width, height } = image;

		if (width === height) {
			canvas.width = width << 0.5;
			canvas.height = height << 0.5;
		} else {
			const rotationAngle = Math.abs(angle);
			canvas.width = width < height ? width : height;
			canvas.height = width > height ? width : height;
			// if (rotationAngle === 90) {
			// } else {
			// 	canvas.width = width < height ? width : height;
			// 	canvas.height = width > height ? width : height;
			// }
		}

		ctx.translate(canvas.width / 2, canvas.height / 2);
		ctx.rotate((angle * Math.PI) / 180);
		ctx.drawImage(image, -width / 2, -height / 2, width, height);

		return new Promise<Blob | null>((resolve, reject) => {
			canvas.toBlob(blob => resolve(blob), fileMime, 1);
		});
	} else throw Error('"ctx" is null!');
}

export function resizeImageWithColor(imageSrc: string, width: number, height: number, colorHex: string, name: string) {
	const canvas = document.createElement('canvas');
	canvas.width = width;
	canvas.height = height;

	const pixelRatio = window.devicePixelRatio;

	const image = document.createElement('img');
	image.src = imageSrc;

	const ctx = canvas.getContext('2d');

	if (ctx !== null) {
		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

		ctx.fillStyle = colorHex;
		ctx.fillRect(0, 0, width, height);

		const dx = image.width / 2;
		const dy = image.height / 2;
		ctx.drawImage(image, width / 2 - dx, height / 2 - dy, image.width, image.height);

		return new Promise<Blob | null>((resolve, reject) => {
			canvas.toBlob(blob => resolve(blob), getFileMime(name), 1);
		});
	} else throw Error('"ctx" is null!');
}

export default {
	exportImage,
	rotateImage,
	resizeImageWithColor
};
